import React from "react";

import { Container } from "./styles";

interface IPixSVG {
  className?: string;
}

const PixSVG2: React.FC<IPixSVG> = ({ className }: IPixSVG) => {
  return (
    <Container className={className}>
      <svg
        width={20}
        height={20}
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clipPath="url(#clip0_8009_10264)">
          <path
            d="M18.717 18.3603C18.2542 18.362 17.7956 18.2719 17.3678 18.0953C16.94 17.9188 16.5514 17.6591 16.2245 17.3315L12.6241 13.7288C12.4967 13.607 12.3273 13.5391 12.1511 13.5391C11.9749 13.5391 11.8055 13.607 11.6782 13.7288L8.06558 17.3414C7.73888 17.6695 7.35039 17.9296 6.92257 18.1067C6.49475 18.2838 6.03607 18.3744 5.57304 18.3732H4.86816L9.43047 22.9355C10.1147 23.6183 11.0419 24.0018 12.0085 24.0018C12.9752 24.0018 13.9024 23.6183 14.5866 22.9355L19.1581 18.3633L18.717 18.3603Z"
            fill="var(--text-color)"
          />
          <path
            d="M5.5738 5.62665C6.03684 5.62542 6.49553 5.71597 6.92335 5.89308C7.35118 6.07019 7.73966 6.33034 8.06634 6.65849L11.6789 10.2718C11.8045 10.397 11.9746 10.4673 12.1519 10.4673C12.3292 10.4673 12.4993 10.397 12.6248 10.2718L16.2245 6.67218C16.5509 6.34361 16.9393 6.08314 17.3672 5.90589C17.7951 5.72863 18.2539 5.63811 18.717 5.63958H19.1505L14.579 1.06816C14.2405 0.729517 13.8386 0.460887 13.3962 0.27761C12.9539 0.0943327 12.4798 0 12.0009 0C11.5221 0 11.048 0.0943327 10.6056 0.27761C10.1633 0.460887 9.76138 0.729517 9.42286 1.06816L4.86816 5.62665H5.5738Z"
            fill="var(--text-color)"
          />
          <path
            d="M22.9318 9.42308L20.1694 6.6606C20.1071 6.68607 20.0405 6.69949 19.9732 6.70014H18.717C18.0634 6.70178 17.4368 6.96138 16.9735 7.42251L13.3738 11.0199C13.0496 11.3435 12.6103 11.5252 12.1523 11.5252C11.6942 11.5252 11.2549 11.3435 10.9307 11.0199L7.31738 7.40882C6.8542 6.94741 6.22759 6.68753 5.57382 6.6857H4.03176C3.96821 6.68427 3.90541 6.67165 3.84623 6.64844L1.06627 9.42308C0.38347 10.1073 0 11.0345 0 12.0012C0 12.9678 0.38347 13.895 1.06627 14.5792L3.84015 17.3531C3.8992 17.3295 3.96208 17.3168 4.02568 17.3159H5.57382C6.22758 17.3139 6.85416 17.0541 7.31738 16.5927L10.93 12.9801C11.5831 12.3277 12.7214 12.3277 13.3738 12.9801L16.9735 16.579C17.4368 17.0402 18.0634 17.2998 18.717 17.3014H19.9732C20.0405 17.3019 20.1071 17.3153 20.1694 17.3409L22.9318 14.5785C23.2705 14.24 23.5391 13.838 23.7224 13.3957C23.9057 12.9533 24 12.4792 24 12.0004C24 11.5216 23.9057 11.0474 23.7224 10.6051C23.5391 10.1627 23.2705 9.76083 22.9318 9.42232"
            fill="var(--text-color)"
          />
        </g>
        <defs>
          <clipPath id="clip0_8009_10264">
            <rect width="24" height="24.0001" fill="white" />
          </clipPath>
        </defs>
      </svg>
    </Container>
  );
};

export default PixSVG2;
